import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDivider, MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSnackBar, MatSnackBarModule } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { Well } from "../../models/well.model";
import { LoggerService } from "../../services/logger.service";
import { WellService } from "../../services/well.service";
import { NGIVAAPService } from "../../services/ivaap.service";

@Component({
  selector: "app-wells",
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatDivider,
    MatSnackBarModule,
    MatDividerModule,
  ],
  templateUrl: "./wells.component.html",
  styleUrls: ["./wells.component.scss"],
})
export class WellsComponent implements OnInit {
  wells: Well[] = [];
  loading = false;
  error: string | null = null;
  mapUrlImage: string = "assets/map.png";

  router = inject(Router);

  constructor(
    private ngIvaapService: NGIVAAPService,
    private wellService: WellService,
    private snackBar: MatSnackBar,
    public logger: LoggerService,
  ) {}

  ngOnInit(): void {
    this.ngIvaapService.ensureLogin().catch((error) => {
      this.logger.error("IVAAP login failed", error);
    });

    // then load wells
    //this.loadWells();
  }

  ngAfterViewInit(): void {
    //this.loadWells();
  }

  loadWells(): void {
    this.loading = true;
    this.error = null;
    this.logger.info("Loading wells");

    this.wellService.getWells().subscribe({
        next: (wells) => {
        this.wells = wells.map((w) => ({ ...w, status: w.status?.toLowerCase() }));
        // this.wells = wells;
        this.loading = false;
        this.logger.info(`Loaded ${wells.length} wells`);
      },
      error: (error) => {
        this.loading = false;
        this.error = "Failed to load wells";
        this.logger.error("Error loading wells", error);
        this.showMessage("Failed to load wells. Using sample data.");
      },
    });
  }

  getMapUrl(well: Well): string | null {
    if (well.well_Latitude == null || well.well_Longitude == null) return null;
    return "source-code\\UI\\src\\assets\\map.png";
  }

  getOperator(well: Well): string {
    const parts = well.operator?.split(":") ?? [];
    return (
      parts[2]?.trim().replace(/%20/g, " ") ||
      well.operator?.trim().replace(/%20/g, " ") ||
      "\u2014"
    );
  }

  getStatusColor(status?: string): string {
    switch (status) {
      case "active":
        return "#388e3c";
      case "inactive":
        return "#757575";
      case "maintenance":
        return "#f57c00";
      default:
        return "#1976d2";
    }
  }

  onNavigateToCanvas(well: Well): void {
    this.router.navigate([well.name, "canvas"], {
      relativeTo: this.router.routerState.root.firstChild,
    });
  }

  onMenuAction(well: Well, action: string): void {
    switch (action) {
      case "Interactive Viewer":
        this.router.navigate([well.name, "canvas"], {
          relativeTo: this.router.routerState.root.firstChild,
        });
        break;
      default:
        this.showMessage(`Action "${action}" not implemented yet`);
    }
  }

  onProductionAction(well: Well, type: string): void {
    this.logger.info(`Production ${type} requested for well ${well.name}`);
    this.showMessage(`Loading ${type} production data for ${well.name}`);

    this.wellService.getProductionData(well.name, type).subscribe({
      next: (data) => {
        this.logger.info(`Loaded production data for ${well.name}`);
        this.showMessage(`${type} production data loaded successfully`);
      },
      error: (error) => {
        this.logger.error(`Error loading production data`, error);
        this.showMessage(`Failed to load ${type} production data`);
      },
    });
  }

  private showMessage(message: string): void {
    this.snackBar.open(message, "Close", {
      duration: 3000,
      horizontalPosition: "end",
      verticalPosition: "top",
    });
  }
}
